interface FormRegex {
    email: RegExp;
    password: RegExp;
    phone_no: RegExp;
    age: RegExp;
    gender: RegExp;
    deliveryType: RegExp;
    language: RegExp;
    snap: RegExp;
    surveyAnswers: RegExp;
    reminderSearch: RegExp;
    zip: RegExp;
    alphaNumeric: RegExp;
    notAllowedOnlySpaces: RegExp;
    shortDate: RegExp;
    tagPattern: RegExp;
}
export const FORM_REGEX: FormRegex = {
    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,// NOSONAR
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$!%*^?&+=])[A-Za-z\d@#$!%*^?&+=]{10,}$/,
    phone_no: /^(\+\d{1,2}\s?)?\(?(\d{3})\)?[\s.-]?(\d{3})[\s.-]?(\d{4})$/,
    age: /^\S[0-9]{0,2}$/,
    gender: /^(male)?$|^(female)?$|^(nonbinary)?$|^(unspecified)?$|^(non-binary)?$/,
    deliveryType: /^(yes)?$|^(no)?$/,
    language: /^(english)?$|^(spanish)?$|^(chinese)?$|^(russian)?$/,
    snap: /^(yes)?$|^(no)?$|^(not indicated)?$/,
    surveyAnswers: /^[0-9]+(, *?[0-9]+)*$/,
    reminderSearch: /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/,
    zip: /^[0-9]{5}$/,
    alphaNumeric: /^[^,]*$/,
    notAllowedOnlySpaces: /^(?! )(?=\S)[^\r\n]*[\s\S]*$/,
    shortDate: /^\d{1,2}\/\d{1,2}\/\d{4}$/,

    //tagPattern allows letters, numbers, spaces, and underscores; prevents tags that are only spaces or underscores.
    tagPattern: /^(?![_ ]*$)[a-zA-Z0-9 _]+$/,
};


export const PHONE_FORMAT_REGEX = {
    US: /^(\d{0,3})(\d{0,3})(\d{0,4})/,
    NUMBERS: /\D/g
};

export const APP_REGEX = {
    LOADING_CHUNK_ERR: 'ChunkLoadError'
}

export const SURVEY_QUESTION_OPTION_REGEX: RegExp = /Press\s+(\w+)\s+for\s+([\w\s\W]*)/;// NOSONAR

export const WORKFLOW_REGEX = {
    CONNECTION_IN: /in/,
    CONNECTION_OUT: /out/
}

export const IC_REGEX = {
    FILE_NAME_EXTR: /^(.+)_\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z(?:\.(\w+))?$/,
    EXTENSION: /\.[^.]+$/
}